/**
* It defines the way to display modal content in UI. such as Dialog, Snackbar, Tooltip etc.
* Corporate with Material components.
* For example, Alert message box needs this setting.
*/
export enum ModalTypes {
    /** Dialog box. */
    Dialog,
    /** Snackbar box. */
    Snackbar,
    /** Tooltip. Not applicable for Kendo Angular UI.*/
    Tooltip
 }
